import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: null,
  course: {
    id: null,
    label_ru: '',
    label_en: '',
    title_ru: '',
    title_en: '',
    description_ru: '',
    description_en: '',
    disclaimer_description_ru: '',
    disclaimer_description_en: '',
    image: '',
    articles: [],
  },
  article: {
    title_ru: '',
    title_en: '',
    description_ru: '',
    description_en: '',
    course: {
      title_ru: '',
      title_en: '',
    },
    article: {
      title_ru: '',
      title_en: '',
    },
  },
};

export const coursesSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {
    setCourses: (state, action) => {
      state.list = action.payload;
    },
    setCourse: (state, action) => {
      state.course = action.payload;
    },
    setArticle: (state, action) => {
      state.article = action.payload;
    },

    resetCourses: () => initialState,
  },
});

export const {
  setCourses,
  setCourse,
  setArticle,

  resetCourses,
} = coursesSlice.actions;

export default coursesSlice.reducer;
